var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSocialYoutube = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 14,
  viewBox: "0 0 20 14",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#006b3f",
  fillRule: "evenodd",
  d: "M10.127 14c-2.247-.07-4.384-.125-6.521-.208a7.43 7.43 0 0 1-1.378-.196C1.386 13.4.803 12.894.504 12.067c-.24-.666-.327-1.352-.39-2.05C-.022 8.378-.022 6.739.045 5.1c.039-.926.063-1.859.31-2.756.15-.537.331-1.063.768-1.45.46-.413 1-.66 1.614-.687C4.42.126 6.1.024 7.786.008c2.266-.023 4.537.008 6.804.051.98.02 1.968.07 2.94.196.89.118 1.555.612 1.91 1.474.271.663.373 1.357.432 2.062.154 1.768.158 3.536.071 5.305-.043.897-.086 1.799-.342 2.673-.291 1.004-.91 1.666-1.94 1.894a7.176 7.176 0 0 1-1.229.133c-2.14.075-4.278.141-6.305.204zM8 10c1.668-.995 3.317-1.982 5-2.99C11.321 6 9.672 5.009 8 4v6z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSocialYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-social-youtube.9abe04eee862093dfdb6b70f396ac62c.svg";